import { render, staticRenderFns } from "./MXN.vue?vue&type=template&id=923691f0&scoped=true"
import script from "./MXN.vue?vue&type=script&lang=js"
export * from "./MXN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923691f0",
  null
  
)

export default component.exports